import React from 'react';

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { isNil } from 'lodash';

import { TimelineProps } from './types';

import cn from '~/utils/cn';

const Timeline: React.FC<TimelineProps> = ({ entries, className, isDefaultExpanded = true }) => {
  return (
    <div className={cn('relative w-full', className)}>
      {entries.map((entry, index) => {
        const isLast = index === entries.length - 1;
        const isContent = !isNil(entry.content);

        return (
          <Disclosure key={entry.id} defaultOpen={isContent && isDefaultExpanded}>
            {({ open }) => {
              const isOpenClasses = !isContent || open;
              const disabled = !isContent;

              return (
                <div className="relative ml-8 pb-12">
                  {/* Clickable timeline line segment */}
                  {!isLast && (
                    <DisclosureButton
                      disabled={disabled}
                      className="hover:bg-opacity-30 absolute top-20 h-full w-12 -translate-x-1/2 cursor-pointer rounded"
                      aria-label={`Toggle ${entry.title}`}
                    >
                      <div className="absolute top-0 bottom-20 left-1/2 w-2 -translate-x-1/2 bg-blue-300"></div>
                    </DisclosureButton>
                  )}

                  {/* Clickable timeline dot */}
                  <DisclosureButton
                    disabled={disabled}
                    className={cn(
                      'absolute mt-2 h-12 w-12 -translate-x-1/2 cursor-pointer rounded-full border-1 border-blue-600 bg-blue-200 transition-all duration-200'
                    )}
                    aria-label={`Toggle ${entry.title}`}
                  ></DisclosureButton>

                  {/* Content area */}
                  <div className="ml-20">
                    <DisclosureButton className="w-full text-left">
                      <div
                        className={cn(
                          'cursor-pointer text-sm font-semibold transition-colors duration-200 hover:text-blue-600',
                          isOpenClasses ? 'text-blue-800' : 'text-blue-700'
                        )}
                      >
                        {entry.title}
                      </div>
                    </DisclosureButton>

                    <div
                      className={cn(
                        'overflow-hidden transition-all duration-500 ease-in-out',
                        // the open effect
                        open ? 'opacity-100' : 'max-h-0 opacity-0'
                      )}
                    >
                      {isContent ? (
                        <DisclosurePanel static className="mt-8">
                          <div className="text-sm font-normal text-blue-800">{entry.content}</div>
                        </DisclosurePanel>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            }}
          </Disclosure>
        );
      })}
    </div>
  );
};

export default Timeline;
